var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ab-wrapper",class:{ loading: _vm.loading }},[_c('div',[_c(_vm.component,{key:_vm.loading,tag:"component",attrs:{"url":_vm.componentUrl,"seo":_vm.seo,"user-info":_vm.userInfo,"instructor":_vm.instructor,"stats":_vm.stats,"version":_vm.componentVersion,"component-version":_vm.componentVersion}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }